<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'SvgIcon',
})
</script>
<template>
  <svg aria-hidden="true" :width="width" :height="height" :viewBox="viewBox"     :style="{ 
      color,
      width: width,  // 直接通过style强制设置宽度
      height: height, // 直接通过style强制设置高度
      maxWidth: 'none', // 解除最大宽度限制
      maxHeight: 'none', // 解除最大高度限制
      flexShrink: 0 // 防止flex布局下被压缩
    }" 
    :aria-label="title"
    >
    <title v-if="title">{{ title }}</title>
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script lang="ts" setup name="SvgIcon">
// 注意svg文件的<svg> 标签上必须有 fill="currentColor" 字段,这样才能从外部的span等标签复制颜色,否则颜色不可变
import { computed } from 'vue'

const props = defineProps({
  prefix: {
    type: String,
    default: 'icon'
  },
  name: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: ''
  },
  width: {
    type: String,
    default: '20px'
  },
  height: {
    type: String,
    default: '20px'
  },
  viewBox: {
    type: String,
    default: '0 0 24 24'
  },
    // 新增：悬浮提示文本
  title: {
    type: String,
    default: ''
  }
})
const symbolId = computed(() => `#${props.prefix}-${props.name}`)
</script>
